import { LOG_SERVICE } from '@common/services/log/log.service.interface';
import { useTranslation } from '@input-web/configs/locale/locale.config';
import { ErrorComponentProps } from '@tanstack/react-router';
import Dialog from '@ui/components/molecules/dialog/dialog.molecule';
import { useCallback, useEffect, useMemo } from 'react';
import { container } from 'tsyringe';

export default function MainErrorView({ error, info }: Partial<ErrorComponentProps>) {
  // #region Dependencies
  const { t } = useTranslation();
  // #endregion

  // #region Handlers
  const handleOnClose = useCallback(() => window.location.reload(), []);
  // #endregion

  // #region Computed Values
  const actions = useMemo(
    () => ({ label: t('label.yes'), onClick: handleOnClose }),
    [handleOnClose, t],
  );
  // #endregion

  // #region Effects
  useEffect(() => {
    if (!error) return;
    container.resolve(LOG_SERVICE).captureError(error, info, { source: 'main-error-view' });
  }, [error, info]);
  // #endregion

  return (
    <Dialog
      actions={actions}
      content={t('error.generic.description')}
      onClose={handleOnClose}
      open
    />
  );
}
